// frontend/src/services/apiService.ts
import api, { CommonResponse } from './api'

// ANCHOR 사용자조회
export const getUser = async () => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getUser')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 로그인
export const signIn = async (account: string, password: string) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/signIn', {
      account,
      password
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 회원가입
export const signUp = async (
  account: string,
  password: string,
  username: string,
  birthDate?: string,
  gender?: string,
  phone?: string,
  email?: string,
  officeId?: number
) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/signUp', {
      account,
      password,
      username,
      birthDate,
      gender,
      phone,
      email,
      officeId
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 로그아웃
export const signOut = async () => {
  try {
    const response = await api.post<CommonResponse>('/api/main/signOut')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 회원 탈퇴
export const withdraw = async () => {
  try {
    const response = await api.post<CommonResponse>('/api/main/withdraw')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 아이디 찾기
export const findAccountByEmail = async (email: string) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/findAccount', { email })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 비밀번호 재설정 요청
export const requestPasswordReset = async (email: string) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/requestPasswordReset', { email })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 비밀번호 재설정 확인
export const confirmPasswordReset = async (token: string) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/confirmPasswordReset', { token })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 비밀번호 변경 (마이페이지)
export const changePassword = async (currentPassword: string, newPassword: string) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/changePassword', {
      currentPassword,
      newPassword
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 사용자 목록 조회 (관리자)
export const getUserList = async (page: number = 1, limit: number = 10) => {
  try {
    const response = await api.get<CommonResponse>('/api/admin/getUserList', {
      params: { page, limit }
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 회원 승인 상태 변경 (관리자)
export const updateUserApprovalStatus = async (id: number, isApproved: boolean) => {
  try {
    const response = await api.put<CommonResponse>(`/api/admin/updateUserApproval/${id}`, {
      isApproved
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 목록 조회
export const getCommunityList = async (page: number = 1, limit: number = 10) => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getCommunityList', {
      params: { page, limit }
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 상세 조회
export const getCommunityDetail = async (id: number) => {
  try {
    const response = await api.get<CommonResponse>(`/api/main/getCommunityDetail/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 작성
export const createCommunity = async (title: string, content: string) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/createCommunity', {
      title,
      content
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 수정
export const updateCommunity = async (id: number, title: string, content: string) => {
  try {
    const response = await api.put<CommonResponse>(`/api/main/updateCommunity/${id}`, {
      title,
      content
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 삭제
export const deleteCommunity = async (id: number) => {
  try {
    const response = await api.delete<CommonResponse>(`/api/main/deleteCommunity/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 좋아요
export const toggleCommunityLike = async (id: number) => {
  try {
    const response = await api.post<CommonResponse>(`/api/main/toggleCommunityLike/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 댓글 작성
export const createComment = async (communityId: number, content: string, parentId?: number) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/createComment', {
      communityId,
      content,
      parentId
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 댓글 수정
export const updateComment = async (id: number, content: string) => {
  try {
    const response = await api.put<CommonResponse>(`/api/main/updateComment/${id}`, {
      content
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 댓글 삭제
export const deleteComment = async (id: number) => {
  try {
    const response = await api.delete<CommonResponse>(`/api/main/deleteComment/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR QnA 목록 조회
export const getQnaList = async (page: number = 1, limit: number = 10) => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getQnaList', {
      params: { page, limit }
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR QnA 상세 조회
export const getQnaDetail = async (id: number) => {
  try {
    const response = await api.get<CommonResponse>(`/api/main/getQnaDetail/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR QnA 작성
export const createQna = async (title: string, question: string, isPrivate: boolean = false) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/createQna', {
      title,
      question,
      isPrivate: isPrivate ? 1 : 0
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR QnA 수정
export const updateQna = async (id: number, title: string, question: string, isPrivate: boolean = false) => {
  try {
    const response = await api.put<CommonResponse>(`/api/main/updateQna/${id}`, {
      title,
      question,
      isPrivate: isPrivate ? 1 : 0
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR QnA 삭제
export const deleteQna = async (id: number) => {
  try {
    const response = await api.delete<CommonResponse>(`/api/main/deleteQna/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR QnA 답변 작성 (관리자)
export const createQnaAnswer = async (id: number, answer: string) => {
  try {
    const response = await api.post<CommonResponse>(`/api/admin/createQnaAnswer/${id}`, {
      answer
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR QnA 답변 수정 (관리자)
export const updateQnaAnswer = async (id: number, answer: string) => {
  try {
    const response = await api.put<CommonResponse>(`/api/admin/updateQnaAnswer/${id}`, {
      answer
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR QnA 답변 삭제 (관리자)
export const deleteQnaAnswer = async (id: number) => {
  try {
    const response = await api.delete<CommonResponse>(`/api/admin/deleteQnaAnswer/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 목록 조회 (관리자)
export const getAdminCommunityList = async (page: number = 1, limit: number = 10) => {
  try {
    console.log('[getAdminCommunityList] 요청 시작', { page, limit })
    const response = await api.get<CommonResponse>('/api/admin/getCommunityList', {
      params: { page, limit }
    })
    console.log('[getAdminCommunityList] 응답 성공', response.data)
    return response
  } catch (error: any) {
    console.error('[getAdminCommunityList] 에러 발생:', error)
    console.error('[getAdminCommunityList] 에러 상세:', {
      message: error.message,
      response: error.response,
      request: error.request,
      config: error.config
    })
    throw error
  }
}

// ANCHOR 커뮤니티 삭제 (관리자)
export const deleteAdminCommunity = async (id: number) => {
  try {
    const response = await api.delete<CommonResponse>(`/api/admin/deleteCommunity/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR QnA 목록 조회 (관리자)
export const getAdminQnaList = async (page: number = 1, limit: number = 10) => {
  try {
    console.log('[getAdminQnaList] 요청 시작', { page, limit })
    const response = await api.get<CommonResponse>('/api/admin/getQnaList', {
      params: { page, limit }
    })
    console.log('[getAdminQnaList] 응답 성공', response.data)
    return response
  } catch (error: any) {
    console.error('[getAdminQnaList] 에러 발생:', error)
    console.error('[getAdminQnaList] 에러 상세:', {
      message: error.message,
      response: error.response,
      request: error.request,
      config: error.config
    })
    throw error
  }
}

// ANCHOR QnA 삭제 (관리자)
export const deleteAdminQna = async (id: number) => {
  try {
    const response = await api.delete<CommonResponse>(`/api/admin/deleteQna/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 공지사항 목록 조회
export const getNoticeList = async (page: number = 1, limit: number = 10) => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getNoticeList', {
      params: { page, limit }
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 공지사항 상세 조회
export const getNoticeDetail = async (id: number) => {
  try {
    const response = await api.get<CommonResponse>(`/api/main/getNoticeDetail/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 공지사항 목록 조회 (관리자)
export const getAdminNoticeList = async (page: number = 1, limit: number = 10) => {
  try {
    console.log('[getAdminNoticeList] 요청 시작', { page, limit })
    const response = await api.get<CommonResponse>('/api/admin/getNoticeList', {
      params: { page, limit }
    })
    console.log('[getAdminNoticeList] 응답 성공', response.data)
    return response
  } catch (error: any) {
    console.error('[getAdminNoticeList] 에러 발생:', error)
    console.error('[getAdminNoticeList] 에러 상세:', {
      message: error.message,
      response: error.response,
      request: error.request,
      config: error.config
    })
    throw error
  }
}

// ANCHOR 이미지 업로드 (Cloudflare Images)
export const uploadImage = async (file: File) => {
  try {
    const formData = new FormData()
    formData.append('file', file)

    const response = await api.post<CommonResponse>('/api/main/uploadImage', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 공지사항 작성 (관리자)
export const createNotice = async (title: string, content: string, images?: File[], isPopup?: boolean) => {
  try {
    const formData = new FormData()
    formData.append('title', title)
    formData.append('content', content)
    formData.append('isPopup', isPopup ? 'true' : 'false')
    
    if (images && images.length > 0) {
      images.forEach((image) => {
        formData.append('images', image)
      })
    }

    const response = await api.post<CommonResponse>('/api/admin/createNotice', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 공지사항 수정 (관리자)
export const updateNotice = async (id: number, title: string, content: string, existingImages?: string[], newImages?: File[], isPopup?: boolean) => {
  try {
    const formData = new FormData()
    formData.append('title', title)
    formData.append('content', content)
    
    if (isPopup !== undefined) {
      formData.append('isPopup', isPopup ? 'true' : 'false')
    }
    
    if (existingImages && existingImages.length > 0) {
      formData.append('existingImages', JSON.stringify(existingImages))
    }
    
    if (newImages && newImages.length > 0) {
      newImages.forEach((image) => {
        formData.append('images', image)
      })
    }

    const response = await api.put<CommonResponse>(`/api/admin/updateNotice/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 팝업 공지 조회
export const getPopupNotice = async () => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getPopupNotice')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 공지사항 삭제 (관리자)
export const deleteAdminNotice = async (id: number) => {
  try {
    const response = await api.delete<CommonResponse>(`/api/admin/deleteNotice/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 자산 목록 조회 (관리자)
export const getAdminAssetList = async (page: number = 1, limit: number = 10) => {
  try {
    const response = await api.get<CommonResponse>('/api/admin/getAssetList', {
      params: { page, limit }
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 자산 등록 (관리자)
export const createAsset = async (location: string, area: number, appraisalValue: string, note?: string) => {
  try {
    const response = await api.post<CommonResponse>('/api/admin/createAsset', {
      location,
      area,
      appraisalValue,
      note
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 자산 수정 (관리자)
export const updateAsset = async (id: number, location: string, area: number, appraisalValue: string, note?: string) => {
  try {
    const response = await api.put<CommonResponse>(`/api/admin/updateAsset/${id}`, {
      location,
      area,
      appraisalValue,
      note
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 자산 삭제 (관리자)
export const deleteAdminAsset = async (id: number) => {
  try {
    const response = await api.delete<CommonResponse>(`/api/admin/deleteAsset/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 자산 목록 조회 (공개)
export const getAssetList = async () => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getAssetList')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 경매사례 목록 조회 (관리자)
export const getAdminAuctionCaseList = async (page: number = 1, limit: number = 10) => {
  try {
    const response = await api.get<CommonResponse>(`/api/admin/getAuctionCaseList?page=${page}&limit=${limit}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 경매사례 등록 (관리자)
export const createAuctionCase = async (title: string, content: string, images?: string[]) => {
  try {
    const response = await api.post<CommonResponse>('/api/admin/createAuctionCase', { title, content, images })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 경매사례 수정 (관리자)
export const updateAuctionCase = async (id: number, title: string, content: string, images?: string[]) => {
  try {
    const response = await api.put<CommonResponse>(`/api/admin/updateAuctionCase/${id}`, { title, content, images })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 경매사례 삭제 (관리자)
export const deleteAdminAuctionCase = async (id: number) => {
  try {
    const response = await api.delete<CommonResponse>(`/api/admin/deleteAuctionCase/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 경매사례 목록 조회 (공개)
export const getAuctionCaseList = async (page: number = 1, limit: number = 10) => {
  try {
    const response = await api.get<CommonResponse>(`/api/main/getAuctionCaseList?page=${page}&limit=${limit}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 경매사례 상세 조회 (공개)
export const getAuctionCaseDetail = async (id: number) => {
  try {
    const response = await api.get<CommonResponse>(`/api/main/getAuctionCaseDetail/${id}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

